export const initialState = {
    is_loading: true,
    total_users: 0,
    total_pages: 0,
    page_number: 1,
    is_creating_new_user: false,
    list: [],
    refresh_count: 0
}